var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Banner"}},[_c('a-carousel',{ref:"loop",attrs:{"autoplay":""}},_vm._l((_vm.bannerImg),function(item,index){return _c('img',{key:index,staticClass:"bannerImg",attrs:{"src":item.img},on:{"click":function($event){return _vm.bannerGame(item)}}})}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-963f8420","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Banner.vue
// module id = null
// module chunks = 